<div class="a-fx a-fx-start-center a-fx-gap-4">
    <span [ngClass]="labelClass" class="a-text-overflow-ellipsis a-text-no-wrap">
        <ng-container *ngTemplateOutlet="labelTmpl"></ng-container>
    </span>

    <span *ngIf="showType$ | async" [ngClass]="typeClass" class="item-type a-fx-none p2">
        <ng-container *ngIf="disableTypeTranslate">{{ type }}</ng-container>
        <ng-container *ngIf="!disableTypeTranslate">{{ type | translate }}</ng-container>
    </span>
</div>

<ng-template #labelTmpl>
    <ng-container *ngIf="truncate">
        {{ label | truncate: [truncate] }}
    </ng-container>

    <ng-container *ngIf="!truncate">
        {{ label }}
    </ng-container>
</ng-template>
